<div #pantallaCompletaRoot class="grafico-pantalla-completa-root" [class.grafico-overlay-activo]="modalAbierto">
    <ion-card class="grafico-avance-visitas-card">
        <ion-card-header>
            <div class="header-container">
            <div class="titulo-container">
                <ion-card-title>{{ titulo }}</ion-card-title>
                <ion-card-subtitle *ngIf="subtitulo">{{ subtitulo }}</ion-card-subtitle>
            </div>
            <div class="acciones-header">
                <ion-button
                    *ngIf="informacion"
                    [id]="idUnico"
                    fill="clear"
                    size="small"
                    class="boton-informacion"
                    aria-label="Información"
                >
                    <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
                </ion-button>
                <ion-button *ngIf="!modalAbierto" class="boton-pantalla-completa" fill="clear" size="small"
                    [disabled]="cargando || !tieneDatosParaGrafico"
                    (click)="abrirPantallaCompleta()"
                    aria-label="Ver gráfico en pantalla completa">
                    <ion-icon name="expand-outline" slot="icon-only"></ion-icon>
                </ion-button>
                <ion-button *ngIf="modalAbierto" class="btn-cerrar-fullscreen" fill="clear" size="small"
                    (click)="cerrarPantallaCompleta()" aria-label="Cerrar pantalla completa">
                    <ion-icon name="close-outline" slot="icon-only"></ion-icon>
                </ion-button>
            </div>
            </div>
        </ion-card-header>
        <ion-card-content>
            <div class="loading-container" *ngIf="cargando">
                <ion-spinner name="crescent"></ion-spinner>
                <p>Cargando datos...</p>
            </div>

            <div class="sin-datos" *ngIf="mostrarSinDatos">
                <ion-icon name="pie-chart-outline"></ion-icon>
                <p>No hay datos disponibles</p>
            </div>

            <div class="grafico-contenedor" *ngIf="mostrarGrafico">
                <div class="loading-container loading-container--overlay" *ngIf="!graficoListo">
                    <ion-spinner name="crescent"></ion-spinner>
                    <p>Cargando datos...</p>
                </div>
                <div class="grafico-fullscreen-body" [class.grafico-fullscreen-body--activo]="modalAbierto">
                    <div class="grafico-wrapper" [class.grafico-listo]="graficoListo"
                        [class.grafico-fullscreen-contenido]="modalAbierto">
                        <canvas #graficoCanvas></canvas>
                    </div>
                    <app-grafico-fullscreen-tabla *ngIf="modalAbierto"
                        [columnas]="columnasTablaFullscreen"
                        [filas]="filasTablaFullscreen">
                    </app-grafico-fullscreen-tabla>
                </div>
            </div>
        </ion-card-content>
    </ion-card>
</div>

<ion-popover
    *ngIf="informacion"
    [trigger]="idUnico"
    triggerAction="click"
    reference="trigger"
    [side]="modalAbierto ? 'bottom' : 'top'"
    alignment="center"
    [cssClass]="modalAbierto ? 'popover-grafico-fullscreen' : undefined"
    [showBackdrop]="modalAbierto"
    [backdropDismiss]="modalAbierto ? true : undefined"
>
    <ng-template>
        <div class="popover-informacion">
            <p>{{ informacion }}</p>
        </div>
    </ng-template>
</ion-popover>
